import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getChannelWithUserData } from '../../../api/channels';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { mergeChannelWithUserData } from '../../../utils/channels';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchChannel = createAsyncThunk(
  'channels/fetchChannel',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [channelResponse, channelUserDataResponse] =
        await getChannelWithUserData(
          {
            path,
            params: {
              ...(params || {}),
              refresh: params?.refresh ? Math.random() : '',
            },
          },
          {
            cancelToken: source.token,
          },
        );
      return mergeChannelWithUserData(channelResponse, channelUserDataResponse);
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchChannelExtraReducers = builder => {
  builder
    .addCase(fetchChannel.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.channel.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(fetchChannel.fulfilled, (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.channel.request[channelCIDKey],
        action,
        () => {
          state.channels.channel.byId[channelCIDKey] = {
            ...action.payload,
            id: channelCIDKey,
            isFavourite: false,
            channelId: action.payload.id,
          };

          if (!state.channels.channel.allIds.includes(channelCIDKey)) {
            state.channels.channel.allIds.push(channelCIDKey);
          }
        },
      );
    })
    .addCase(fetchChannel.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.channel.request[
          generateChannelCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
